/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function useEPCreationDialog() {
  const { t } = useTranslation();
  const { control, handleSubmit, errors, formState } = useForm({ mode: 'onChange' });
  const languageList = [
    {
      itemId: 'en',
      itemLabel: t('enum.languages.english'),
      type: 'EP',
    },
    {
      itemId: 'fr',
      itemLabel: t('enum.languages.french'),
      type: 'EP',
    },
    {
      itemId: 'de',
      itemLabel: t('enum.languages.german'),
      type: 'EP',
    },
  ];

  const defaultLanguage = 'en';
  const paymentMethodsList = [
    { itemId: 'AUTO', itemLabel: t('enum.payment-method.AUTO') },
    { itemId: 'DEPOSIT_ACCOUNT', itemLabel: t('enum.payment-method.DEPOSIT_ACCOUNT') },
    { itemId: 'BANK_TRANSFER', itemLabel: t('enum.payment-method.BANK_TRANSFER') },
    { itemId: 'CREDIT_CARD', itemLabel: t('enum.payment-method.CREDIT_CARD') },
    { itemId: 'NONE', itemLabel: t('enum.payment-method.NONE') },
  ];
  const defaultPaymentMethod = 'AUTO';

  const userReferenceRules = {
    required: t('user.reference.required'),
    maxLength: { value: 23, message: t('submission.epct.createDialog.maxLength.pattern') },
    pattern: {
      value: /^[\da-zA-Z-]*$/,
      message: t('submission.epct.createDialog.fileReference.pattern'),
    },
  };

  return {
    paymentMethodsList,
    defaultPaymentMethod,
    languageList,
    defaultLanguage,
    userReferenceRules,
    control,
    handleSubmit,
    errors,
    formState,
    t,
  };
}
